export enum ELoadingStatus {
  noData = 'noData',
  loading = 'loading',
  loadingFirstInit = 'loadingFirstInit',
  loaded = 'loaded',
  error = 'error',
}
